let Socket = null
let setIntervalWesocketPush = null
let eventProcessorMap = new Map()
import evn from "./evn";
import {Decrypt} from '@/request/customer/util.js'
import chatApi from '@/request/customer/customerRoom'
import store from '@/store/index';
const { VUE_APP_IM_SOCKET_API } = process.env

/**
 * 建立websocket连接
 */
const createSocket = () => {
  Socket && Socket.close()
  if (!Socket) {
    console.log('服务连接成功1')
    Socket = new WebSocket(VUE_APP_IM_SOCKET_API+'&token='+localStorage.getItem('cusetomerTokens'))
    Socket.onopen = onopenWS
    Socket.onmessage = onmessageWS
    Socket.onerror = onerrorWS
    Socket.onclose = oncloseWS
    store.commit('set_chatStatus', true)
  } else {
    console.log('服务已连接')
  }
}

/**打开WS之后发送心跳 */
const onopenWS = (e) => {
  sendPing()
}

/**连接失败重连 */
const onerrorWS = () => {
  Socket.close()
  clearInterval(setIntervalWesocketPush)
  if (Socket.readyState !== 3) {
    Socket = null
    store.commit('set_chatStatus', false)
    createSocket()
  }
}

/**WS数据接收统一处理 */
const onmessageWS = (e) => {
  try {
    if(e.data.toString().length> 10){
      let data = JSON.parse(Decrypt(e.data))||[]
      let newobj = {}; 
      data = data.reduce((preVal, curVal) => {
        newobj[curVal.data.id] ? '' : newobj[curVal.data.id] = preVal.push(curVal); 
        return preVal 
      }, [])
      data.forEach(item => {
        if (eventProcessorMap.has(item.act)) {
          eventProcessorMap.get(item.act)(item)
        }
      });
    }
  } catch (e) {
    console.log(e)
  }
}

/**
 * 发送数据但连接未建立时进行处理等待重发
 * @param {any} message 需要发送的数据
 */
const connecting = message => {
  setTimeout(() => {
    if (Socket.readyState === 0) {
      connecting(message)
    } else {
      Socket.send(JSON.stringify(message))
    }
  }, 1000)
}

/**
 * 发送数据
 * @param {any} message 需要发送的数据
 */
const sendWSPush = message => {
  if (Socket !== null && Socket.readyState === 3) {
    Socket.close()
    createSocket()
  } else if (Socket.readyState === 1) {
    Socket.send(JSON.stringify(message))
  } else if (Socket.readyState === 0) {
    connecting(message)
  }
}

/**断开重连 */
const oncloseWS = async () => {
  clearInterval(setIntervalWesocketPush)
  console.log('服务已断开....正在尝试重连')
  if (Socket.readyState !== 2) {
    Socket = null
    // store.commit('set_chatStatus', false)
    store.commit('set_chatCount')
    if(store.state.chatCount<=3){
      if(store.state.chatCount>2){
        await chatApi.getToken({
          format: "json",
          type: 2,
          userid: store.state.userData.telphone,
        }).then(res => {
          localStorage.setItem('cusetomerTokens', JSON.parse(Decrypt(res.msg)).token)
        })
      }
      if(localStorage.getItem('cusetomerTokens') !== null && localStorage.getItem('cusetomerTokens') !== ''){
        createSocket()
      }
    }
  }
}
/**发送心跳
 * @param {number} time 心跳间隔毫秒 默认5000
 * @param {string} ping 心跳名称 默认字符串ping
 */
const sendPing = (time = 50000, ping = 'ping') => {
  clearInterval(setIntervalWesocketPush)
  Socket.send(ping)
  setIntervalWesocketPush = setInterval(() => {
    Socket.send(ping)
  }, time)
}

/**
 * 绑定接收事件
 * @param eventType 事件类型 String
 * @param Processor 回调函数 Function
 */
const on = (eventType, Processor) => {
  eventProcessorMap.set(eventType, Processor)
}

export default {
  createSocket,
  sendWSPush,
  on
}
